<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8">
        <h1>Nuevo Ticket</h1>
        <v-form v-model="isFormValid" ref="form" class="my-4">
          <v-text-field
            v-model="ticketData.subject"
            label="Asunto del Ticket"
            dense
            :rules="[rules.required]"
            required
            outlined
          ></v-text-field>
          <v-select
            v-model="ticketData.them"
            :items="filteredTema"
            label="Tema de ayuda"
            dense
            outlined
            :rules="[rules.required]"
            required
          ></v-select>

          <div>

            <v-textarea
              v-model="ticketData.description"
              :label="
                ticketData.them == 'Alta de Embarcaciones' ||
                ticketData.them == 'Alta de Agencias' ||
                ticketData.them == 'Alta de Usuarios'
                  ? 'Motivo del alta'
                  : ticketData.them == 'Baja de Usuario'
                  ? 'Motivo de la baja'
                  : ticketData.them == 'Reactivar Usuario'
                  ? 'Motivo de la reactivación'
                  : ticketData.them == 'Actualización de Usuario'
                  ? 'Descripción de los cambios'
                  : 'Descripción del problema'
              "
              :rules="[rules.required]"
              required
              outlined
            ></v-textarea>

            <v-select
              v-model="ticketData.priority"
              :items="['Baja', 'Media', 'Alta']"
              label="Prioridad"
              dense
              :rules="[rules.required]"
              outlined
              required
            ></v-select>
          </div>
          <div v-if="ticketData.them == 'Alta de Embarcaciones'">
            <v-row dense>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="embarcacionData.nombre"
                  label="Nombre de buque"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.armador"
                  label="Armador"
                ></v-text-field>
              </v-col>

              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  :rules="[rules.required]"
                  outlined
                  required
                  v-model="embarcacionData.bandera"
                  label="Bandera"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.pto_matricula"
                  label="Pto Matricula"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.eslora"
                  type="number"
                  label="Eslora"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="embarcacionData.puntal"
                  type="number"
                  label="Puntal"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  :rules="[rules.required]"
                  outlined
                  required
                  type="number"
                  v-model="embarcacionData.manga"
                  label="Manga"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  :rules="[rules.required]"
                  outlined
                  required
                  v-model="embarcacionData.trn"
                  type="number"
                  label="TRN"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.tbr"
                  type="number"
                  label="TRB"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  :rules="[rules.required]"
                  outlined
                  required
                  v-model="embarcacionData.matricula"
                  label="No. Matricula"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="embarcacionData.calado"
                  label="Calado"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.imo"
                  label="IMO"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="embarcacionData.tipo"
                  label="Clase"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div v-if="ticketData.them == 'Alta de Agencias'">
            <v-row dense>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="agenciasData.nombre"
                  label="Nombre o razón social"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="agenciasData.direccion"
                  label="Dirección"
                ></v-text-field>
              </v-col>

              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="agenciasData.rfc"
                  label="RFC"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3">
                <v-text-field
                  dense
                  outlined
                  :rules="[rules.required]"
                  required
                  v-model="agenciasData.email"
                  label="E-mail"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="agenciasData.representante"
                  label="Representante"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div v-if="ticketData.them == 'Alta de Usuarios'">
            <v-row dense>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="usuarioData.nombre"
                  label="Nombre completo"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required, rules.email]"
                  v-model="usuarioData.email"
                  label="Correo electrónico"
                  type="email"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="usuarioData.empresa"
                  label="Empresa"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  v-model="usuarioData.telefono"
                  label="Teléfono"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="6" sm="6" md="6">
                <v-select
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="usuarioData.rol"
                  :items="roles"
                  label="Rol"
                ></v-select>
              </v-col> -->
              <v-col cols="6" sm="6" md="6">
                <v-select
                  dense
                  outlined
                  disabled
                  v-model="usuarioData.agencia"
                  :items="agenciasList"
                  item-text="text"
                  item-value="value"
                  label="Agencia"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  v-model="usuarioData.cargo"
                  label="Cargo"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  dense
                  outlined
                  required
                  :rules="[rules.required, rules.minLength]"
                  v-model="usuarioData.password"
                  label="Contraseña inicial"
                  type="password"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <!-- Baja de Usuario / Reactivar Usuario / Actualización de Usuario -->
          <div v-if="esOperacionUsuarioExistente">
            <v-row dense>
              <v-col cols="12">
                <v-select
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                  v-model="usuarioRefId"
                  :items="usuariosFiltrados"
                  item-text="text"
                  item-value="value"
                  :label="
                    ticketData.them === 'Reactivar Usuario'
                      ? 'Usuario inactivo a reactivar'
                      : ticketData.them === 'Baja de Usuario'
                      ? 'Usuario activo a dar de baja'
                      : 'Usuario activo a actualizar'
                  "
                  :loading="loadingUsuarios"
                  :no-data-text="'Sin usuarios disponibles'"
                  @change="onUsuarioSeleccionado"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Campos editables solo para Actualización de Usuario -->
            <div v-if="ticketData.them === 'Actualización de Usuario' && usuarioRefId">
              <v-divider class="mb-3"></v-divider>
              <p class="caption grey--text mb-2">Modifica los campos que deseas actualizar:</p>
              <v-row dense>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    dense outlined required
                    :rules="[rules.required]"
                    v-model="usuarioActualizacion.nombre"
                    label="Nombre completo"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    dense outlined required
                    :rules="[rules.required, rules.email]"
                    v-model="usuarioActualizacion.email"
                    label="Correo electrónico"
                    type="email"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    dense outlined required
                    :rules="[rules.required]"
                    v-model="usuarioActualizacion.empresa"
                    label="Empresa"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    dense outlined
                    v-model="usuarioActualizacion.telefono"
                    label="Teléfono"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="6" sm="6" md="6">
                  <v-select
                    dense outlined required
                    :rules="[rules.required]"
                    v-model="usuarioActualizacion.rol"
                    :items="roles"
                    label="Rol"
                  ></v-select>
                </v-col> -->
                <!-- <v-col cols="6" sm="6" md="6">
                  <v-select
                    dense outlined clearable
                    v-model="usuarioActualizacion.agencia"
                    :items="agenciasList"
                    item-text="text"
                    item-value="value"
                    label="Agencia"
                  ></v-select>
                </v-col> -->
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    dense outlined
                    v-model="usuarioActualizacion.cargo"
                    label="Cargo"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>

          <v-file-input
            v-model="file"
            :rules="fileRules"
            dense
            @change="validateFileSize"
            show-size
            :label="
              ticketData.them == 'Alta de Embarcaciones'
                ? 'Certificado de Arqueo'
                : 'Evidencia'
            "
            accept="image/*,.pdf"
            outlined
          ></v-file-input>

          <v-btn
            :disabled="!isFormValid"
            color="primary"
            :loading="loading"
            @click="submitTicket"
            >Enviar Ticket</v-btn
          >
        </v-form>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Resumen de Tickets</v-card-title>
          <v-divider></v-divider>
          <v-list nav dense>
            <v-list-item-group v-model="selectedItem" color="blue">
              <v-list-item @click="irSeguimiento('abiertos')">
                <v-list-item-avatar>
                  <v-icon color="red">pending</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="ml-3">Abiertos</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small color="gray" dark> {{ tickets["abiertos"] }} </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item @click="irSeguimiento('en proceso')">
                <v-list-item-avatar>
                  <v-icon color="orange">timer</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="ml-3">En proceso</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small color="gray" dark> {{ tickets["en_proceso"] }} </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item @click="irSeguimiento('resueltos')">
                <v-list-item-avatar>
                  <v-icon color="green">check</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="ml-3">Resueltos</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small color="gray" dark> {{ tickets["resueltos"] }} </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item @click="irSeguimiento('cerrados')">
                <v-list-item-avatar>
                  <v-icon color="black">task_alt</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="ml-3">Cerrados</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small color="gray" dark> {{ tickets["cerrados"] }} </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item @click="irSeguimiento('cancelados')">
                <v-list-item-avatar>
                  <v-icon color="black">delete</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="ml-3">Cancelados</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small color="black" dark> {{ tickets["cancelados"] }} </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { crearTicket, getTickets, selectAgencias, getUsuariosPorAgencia } from "../../api/endpoints";
import { uploadDocument } from "../../helpers/handleUploadsDocument";

export default {
  data() {
    return {
      isFormValid: false,
      ticketData: {
        subject: "",
        them: "",
        description: "",
        priority: "",
      },
      embarcacionData: {
        nombre: "",
        armador: "",
        bandera: "",
        pto_matricula: null,
        eslora: null,
        puntal: null,
        manga: null,
        trn: null,
        tbr: null,
        matricula: "",
        calado: "",
        imo: "",
        tipo: "",
      },
      agenciasData: {
        nombre: "",
        direccion: "",
        rfc: "",
        email: "",
        representante: "",
      },
      usuarioData: {
        nombre: "",
        email: "",
        empresa: "",
        telefono: "",
        rol: "",
        agencia: null,
        cargo: "",
        password: "",
      },
      agenciasList: [],
      roles: ["Agencia", "Cliente", "Vigilante", "PSP", "APITAB", "Administrador"],
      // Operaciones sobre usuarios existentes
      usuariosFiltrados: [],
      loadingUsuarios: false,
      usuarioRefId: null,
      usuarioRefData: null,
      usuarioActualizacion: {
        nombre: "",
        email: "",
        empresa: "",
        telefono: "",
        rol: "",
        agencia: null,
        cargo: "",
      },
      isAdmin: false,
      tema: [
        "Problemas de Acceso a la Cuenta",
        "Alta de Embarcaciones",
        "Alta de Agencias",
        "Alta de Usuarios",
        "Baja de Usuario",
        "Reactivar Usuario",
        "Actualización de Usuario",
        "Recuperación de Contraseña",
        "Errores en la Aplicación",
        "Soporte Técnico General",
        "Consultas sobre Actualizaciones",
        "Funciones No Disponibles",
        "Configuración de la Cuenta",
        "Cambios en Datos Personales",
        "Problemas con Notificaciones",
        "Cancelación de Servicios",
        "Sugerencias y Mejoras",
        "Otro",
      ],
      loading: false,
      selectedItem: "",
      tickets: [],
      file: null,
      usuario_log: null,
      fileRules: [
        (file) => this.isFileSizeValid(file) || "El archivo debe ser menor de 2 MB",
      ],
      rules: {
        required: (value) => !!value || "Este campo es requerido",
        email: (value) => /.+@.+\..+/.test(value) || "Correo electrónico inválido",
        minLength: (value) => (value && value.length >= 6) || "Mínimo 6 caracteres",
      },
    };
  },
  computed: {
    filteredTema() {
      if (this.$store.state.usuario.rol !== "Agencia") {
        return this.tema;
      }
      return this.tema.filter((item) => item !== "Alta de Agencias");
    },
    esOperacionUsuarioExistente() {
      return ["Baja de Usuario", "Reactivar Usuario", "Actualización de Usuario"].includes(
        this.ticketData.them
      );
    },
    estadoFiltroUsuarios() {
      return this.ticketData.them === "Reactivar Usuario" ? 0 : 1;
    },
  },
  watch: {
    "ticketData.them"(newVal) {
      this.usuarioData.agencia = this.$store.state.usuario.agencia;
      if (this.esOperacionUsuarioExistente) {
        this.usuariosFiltrados = [];
        this.usuarioRefId = null;
        this.usuarioRefData = null;
        this.cargarUsuariosFiltrados();
      }
    },
  },
  created() {
    this.getTicketsResume();
    this.cargarAgencias();
  },
  methods: {
    async submitTicket() {
      // Aquí puedes manejar la lógica de envío del ticket
      this.loading = true;

      if (this.$refs.form.validate()) {
        let evidencia = "";
        if (this.file) {
          evidencia = await uploadDocument(this.file);
        }
        const datos = {
          asunto: this.ticketData.subject,
          tema: this.ticketData.them,
          descripcion: this.ticketData.description,
          prioridad: this.ticketData.priority,
          evidencia: evidencia,
        };
        if (this.ticketData.them == "Alta de Embarcaciones") {
          datos.dataEmbarcacion = JSON.stringify(this.embarcacionData);
        }
        if (this.ticketData.them == "Alta de Agencias") {
          datos.dataAgencias = JSON.stringify(this.agenciasData);
        }
        if (this.ticketData.them == "Alta de Usuarios") {
          const new_data = { ...datos.dataUsuario, rol: "Agencia" }
          datos.dataUsuario = JSON.stringify(new_data);
        }
        if (this.ticketData.them === "Baja de Usuario" || this.ticketData.them === "Reactivar Usuario") {
          datos.dataUsuario = JSON.stringify(this.usuarioRefData);
        }
        if (this.ticketData.them === "Actualización de Usuario") {
          datos.dataUsuario = JSON.stringify({
            _id: this.usuarioRefId,
            ...this.usuarioActualizacion,
          });
        }
        crearTicket(datos)
          .then(() => {
            this.$notify({
              title: "¡Éxito!",
              text: "La operación se completo con éxito",
              type: "success",
            });
            this.getTicketsResume();
            this.resetForm();
          })
          .catch((err) => {
            const msg =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : "La operación no se completó, revise con el administrador";
            this.$notify({
              title: "¡Error!",
              text: msg,
              type: "error",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    async getTicketsResume() {
      this.loading = true;
      await getTickets()
        .then((e) => {
          this.tickets = e;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    irSeguimiento(estatus) {
      this.$router.push({ name: "soporte_estatus", params: { estatus } });
    },
    resetForm() {
      // Limpiar los datos del formulario
      this.ticketData = {
        subject: "",
        them: "",
        description: "",
        priority: "",
      };
      this.usuarioData = {
        nombre: "",
        email: "",
        empresa: "",
        telefono: "",
        rol: "",
        agencia: null,
        cargo: "",
        password: "",
      };
      this.usuariosFiltrados = [];
      this.usuarioRefId = null;
      this.usuarioRefData = null;
      this.usuarioActualizacion = {
        nombre: "",
        email: "",
        empresa: "",
        telefono: "",
        rol: "",
        agencia: null,
        cargo: "",
      };

      // Resetear la validación del formulario
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    async cargarAgencias() {
      try {
        this.agenciasList = await selectAgencias();
      } catch (err) {
        console.error("Error al cargar agencias:", err);
      }
    },
    async cargarUsuariosFiltrados() {
      this.loadingUsuarios = true;
      this.usuarioRefId = null;
      this.usuarioRefData = null;
      try {
        this.usuariosFiltrados = await getUsuariosPorAgencia(
          this.$store.state.usuario.agencia,
          this.estadoFiltroUsuarios
        );
      } catch (err) {
        console.error("Error al cargar usuarios:", err);
        this.usuariosFiltrados = [];
      } finally {
        this.loadingUsuarios = false;
      }
    },
    onUsuarioSeleccionado(id) {
      // const found = this.usuariosFiltrados.find((u) => u.value === id);
      // this.usuarioRefData = found ? found.data : null;
      // if (this.ticketData.them === "Actualización de Usuario" && found) {
      //   this.usuarioActualizacion = { ...found.data };
      //   delete this.usuarioActualizacion._id;
      // }
    },
    isFileSizeValid(file) {
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
      return file && file.size <= maxSizeInBytes;
    },
    validateFileSize(file) {
      if (!this.isFileSizeValid(file)) {
        this.file = null;
        this.$emit("input", null); // Limpia el archivo en caso de exceder el límite
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  margin-top: 20px;
}
</style>
